<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="row text-muted">
                <div class="col-6 text-left"></div>
                <div class="col-6 text-right"><p class="mb-0">&copy; 2020 - <a href="/" class="text-muted">CRM</a></p></div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>
